import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SparklesIcon, ArrowRightIcon, RocketIcon } from 'lucide-react';
// GHOST PAGE — /Agency
// Unlisted route (not linked in the navbar or footer). Share the direct URL
// to reach it: https://trippinwithmandy.com/Agency
//
// To attach the other Magic Patterns project, drop its published URL into
// AGENCY_PROJECT_URL below. While it's empty, a branded placeholder shows.
const AGENCY_PROJECT_URL = '';
export function AgencyPage() {
  return <div className="min-h-screen bg-gradient-to-b from-plum-900 via-plum-800 to-plum-900 pt-28 pb-24 overflow-hidden relative" data-id="element-604">
      {/* Decorative glow */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-cta-500/20 rounded-full blur-[120px] pointer-events-none" data-id="element-605" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-lavender-500/20 rounded-full blur-[120px] pointer-events-none" data-id="element-606" />
      <SparkleEffect count={100} data-id="element-607" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-608">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-609">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-610">
            <SparklesIcon className="w-4 h-4 text-cta-400" data-id="element-611" />
            The Agency
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-612">
            Trippin' <span className="shimmer-text" data-id="element-613">Agency</span>
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-614">
            Where the brand becomes a business. Real design, real strategy, real
            results — built the no-BS way.
          </p>
        </motion.div>

        {/* Project Embed / Placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="rounded-[2rem] overflow-hidden border border-white/15 shadow-2xl bg-white/5 backdrop-blur-sm" data-id="element-615">
          {AGENCY_PROJECT_URL ? <iframe src={AGENCY_PROJECT_URL} title="Trippin' Agency" className="w-full h-[80vh] min-h-[600px] border-0 bg-white" loading="lazy" data-id="element-616" /> : <div className="flex flex-col items-center justify-center text-center px-6 py-24 min-h-[480px]" data-id="element-617">
              <div className="w-16 h-16 rounded-2xl bg-cta-500/20 border border-cta-500/40 flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(214,51,133,0.3)]" data-id="element-618">
                <RocketIcon className="w-8 h-8 text-cta-300" data-id="element-619" />
              </div>
              <h2 className="font-heading text-3xl font-bold text-white mb-3" data-id="element-620">
                Project Ready to Attach
              </h2>
              <p className="text-white/70 max-w-md font-medium leading-relaxed mb-8" data-id="element-621">
                This is the home for your agency project. Once it's connected,
                it'll load right here on this page.
              </p>
              <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white/80 text-sm font-bold" data-id="element-622">
                <GlitterHeart size={16} variant="light" data-id="element-623" />
                Awaiting project link
                <ArrowRightIcon className="w-4 h-4" data-id="element-624" />
              </div>
            </div>}
        </motion.div>
      </div>
    </div>;
}